<script lang="ts">
  import type { SortableItemType } from "interfaces/Sort.interface";

  export let item: SortableItemType;
  export let cardThis: any;

</script>

<svelte:component {item} this={cardThis}/>
